var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamMissionLowerBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_183_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.59361e-05V11.0705L2.53655 13.1071L20.5 13.107V2.00097L18.4634 0C-10.5982 0 29.5564 1.59361e-05 0.5 1.59361e-05Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.525 11.0601V0.0250159L18.4532 0.025L20.475 2.01146V13.082L2.54691 13.0821L0.525 11.0601Z",
    stroke: "url(#paint0_linear_183_9)",
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.525 11.0601V0.0250159L18.4532 0.025L20.475 2.01146V13.082L2.54691 13.0821L0.525 11.0601Z",
    stroke: "url(#paint1_linear_183_9)",
    strokeWidth: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_183_9",
    x: -22.5,
    y: -23,
    width: 66,
    height: 59.1074,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_183_9"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_183_9",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_183_9",
    x1: 0.0784527,
    y1: -1.57058,
    x2: 12.1924,
    y2: 6.40153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_183_9",
    x1: 21.9813,
    y1: 16.0944,
    x2: 15.4577,
    y2: 12.8559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMissionLowerBackground);
export default __webpack_public_path__ + "static/media/team_mission_lower_background.c8e4f6822bc07d4f7ab735355974beaa.svg";
export { ForwardRef as ReactComponent };